import styled from '@emotion/styled'

export const TabPaneContentBase = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 16px 32px;
`
